import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/Preguntas_PER.css';
import { useNavigate } from 'react-router-dom';
import { useUserPermissions } from './UserContext';

function Preguntas_PER() {
    const userPermissions = useUserPermissions();
    const username = userPermissions?.username || '';
    const email = userPermissions?.email || '';
    const ruta = userPermissions?.ruta || ''; // Accede a los datos pasados
    const [selectedTema, setSelectedTema] = useState('');
    const [selectedExamen, setSelectedExamen] = useState('');
    const [selected, setSelected] = useState('');
    const [temas, setTemas] = useState([]);
    const [examen, setExamen] = useState([]);
    const navigate = useNavigate(); // Hook para la navegación
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [restablecerTemas, setRestablecerTemas] = useState(false);
    const [restablecerExamenes, setRestablecerExamenes] = useState(false);
    const [continuarTemas, setContinuarTemas] = useState(false);
    const [continuarExamenes, setContinuarExamenes] = useState(false);
    const [arrayPreguntasTema, setArrayPreguntasTema] = useState([]);
    const [arrayPreguntasExamen, setArrayPreguntasExamen] = useState([]);


    useEffect(() => {
        // Llama a las funciones para obtener los temas y exámenes cuando el componente se monta
        if (!showModal && !showModal2 && username != '') {
            consultPerTemas();
            consultPerExamenes();
        }
        
        if (showModal && (restablecerTemas || continuarTemas)) {
            handleFetchAndRedirect();
          }
          if (showModal2 && (restablecerExamenes || continuarExamenes)) {
            handleFetchAndRedirect2();
          }
       
    }, [restablecerTemas, continuarTemas, showModal, restablecerExamenes, continuarExamenes]); // El array vacío significa que se ejecutará solo una vez

    const consultPerTemas = async () => {
        try {
            const response = await fetch(ruta + '/consulta_per_temas', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, email })
            });

            if (response.ok) {
                const data = await response.json();
                setTemas(data);
            } else {
                console.log('Error en la respuesta del servidor.');
            }
        } catch (error) {
            console.log('Error:', error);
            // Puedes agregar una función para mostrar mensajes de error si es necesario
        }
    };

    const consultPerExamenes = async () => {
        try {
            const response = await fetch(ruta + '/consulta_per_examenes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, email })
            });

            if (response.ok) {
                const data = await response.json();
                setExamen(data);
            } else {
                console.error('Error en la respuesta del servidor.');
            }
        } catch (error) {
            console.error('Error:', error);
            // Puedes agregar una función para mostrar mensajes de error si es necesario
        }
    };

    const mostrarModal1 = async () => {
        if (!selectedTema) {
            alert("Por favor, selecciona un tema.");
            return;
        }
        const response = await fetch(ruta + '/sesion_per_temas', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, email, selectedTema })
        });

        if (response.ok) {
            const data = await response.json();
            setArrayPreguntasTema(data);
            setShowModal(true); // Muestra el modal cuando el usuario haga clic
        }
        else {
            handleFetchAndRedirect();
        }
    }

    const mostrarModal2 = async () => {
        if (!selectedExamen) {
            alert("Por favor, selecciona un examen.");
            return;
        }
        const response = await fetch(ruta + '/sesion_per_examen', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username, email, selectedExamen })
        });

        if (response.ok) {
            const data = await response.json();
            setArrayPreguntasExamen(data);
            setShowModal2(true); // Muestra el modal cuando el usuario haga clic
        }
        else {
            handleFetchAndRedirect2();
        }
    }

    const handleFetchAndRedirect = async () => {
        if (restablecerTemas == true || continuarTemas == false) {
            console.log("Entra en el primero");
            try {

                const response = await fetch(ruta + `/preguntas_per_temas?tema=${selectedTema}&username=${username}&email=${email}`);
                const preguntas = await response.json();

                navigate('/Ver_preguntas', { state: { preguntas: preguntas, selected: selectedTema, posicion: 0, aciertos:0, fallos:0 } });
            } catch (error) {
                console.error("Error al descargar las preguntas:", error);
            }
        }
        else if (restablecerTemas == false && continuarTemas == true) {
            try {
                const response = await fetch(ruta + '/generar_preguntas_per_temas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selectedTema })
                });
                const preguntas = await response.json();
                const response2 = await fetch(ruta + '/posicion_preguntas_per_temas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selectedTema })
                });
                const {posicion} = await response2.json();
                const response3 = await fetch(ruta + '/aciertos_preguntas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selected: selectedTema })
                });
                const {aciertos} = await response3.json();
                const response4 = await fetch(ruta + '/fallos_preguntas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selected: selectedTema })
                });
                const {fallos} = await response4.json();
                console.log("Buen camino:");
                navigate('/Ver_preguntas', { state: { preguntas: preguntas, selected: selectedTema, posicion: posicion, aciertos:aciertos, fallos:fallos} });
            } catch (error) {
                console.error("Error al descargar las preguntas:", error);
            }
        }
    };

    const handleFetchAndRedirect2 = async () => {
        if (restablecerExamenes == true || continuarExamenes == false) {
            try {

                const response = await fetch(ruta + `/preguntas_per_examen?examen=${selectedExamen}&username=${username}&email=${email}`);
                const preguntas = await response.json();

                navigate('/Ver_preguntas', { state: { preguntas: preguntas, selected: selectedExamen, posicion: 0, aciertos:0, fallos: 0 } });
            } catch (error) {
                console.error("Error al descargar las preguntas:", error);
            }
        }
        else if (restablecerExamenes == false && continuarExamenes == true) {
            try {
                const response = await fetch(ruta + '/generar_preguntas_per_examenes', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selectedExamen })
                });
                const preguntas = await response.json();
                const response2 = await fetch(ruta + '/posicion_preguntas_per_examenes', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selectedExamen })
                });
                const {posicion} = await response2.json();
                const response3 = await fetch(ruta + '/aciertos_preguntas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selected: selectedExamen })
                });
                const {aciertos} = await response3.json();
                const response4 = await fetch(ruta + '/fallos_preguntas', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ username, email, selected: selectedExamen })
                });
                const {fallos} = await response4.json();
                navigate('/Ver_preguntas', { state: { preguntas: preguntas, selected: selectedExamen, posicion: posicion, aciertos:aciertos, fallos:fallos} });
            } catch (error) {
                console.error("Error al descargar las preguntas:", error);
            }
        }
    };

    const restablecer1 = async () => {
        setRestablecerTemas(true);
        setContinuarTemas(false);
        setRestablecerExamenes(false);
        setContinuarExamenes(false);
    }

    const continuar1 = async () => {
        setContinuarTemas(true);
        setRestablecerTemas(false);
        setRestablecerExamenes(false);
        setContinuarExamenes(false);
    }


    const restablecer2 = () => {
        setRestablecerExamenes(true);
        setContinuarExamenes(false);
        setContinuarTemas(false);
        setRestablecerTemas(false);
    }

    const continuar2 = () => {
        setContinuarExamenes(true);
        setRestablecerExamenes(false);
        setContinuarTemas(false);
        setRestablecerTemas(false);
    }

    return (
        <>
            <div className='contenedor_principal_per_preguntas'>
                <div className='row col-12 text-center d-flex justify-content-center align-items-center'>
                <div className='conjunto_p col-12 col-md-6 col-lg-6'>
                <div className='titulo_t col-10 col-md-10 col-lg-10'>Temas</div>
                    <div className='preguntas_por_temas_2 col-10 col-md-10 col-lg-10'>
                        <div className='separacion_p'>
                            <select
                                id="temasSelect"
                                value={selectedTema}
                                onChange={(e) => { setSelectedTema(e.target.value); setSelected(e.target.value) }}
                            >
                                <option value="">Seleccione un tema</option>
                                {temas.map((tema) => (
                                    <option key={tema.id} value={tema.tema}>
                                        {tema.tema}
                                    </option>
                                ))}
                            </select>
                            <p></p>
                            <div>
                                <button className='separacion_p boton_per col-10' onClick={mostrarModal1}>
                                    Ver Preguntas
                                </button>
                                {
                                    showModal && (<Seleccionador onRestablecer={restablecer1} onContinuar={continuar1} />)
                                }
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className='conjunto_p col-12 col-md-6 col-lg-6'>
                <div className='titulo_t col-10 col-md-10 col-lg-10'>Exámenes</div>
                
                    <div className='preguntas_por_examen_2 col-10 col-md-10 col-lg-10'>

                        <div className='separacion_p'>
                            <select
                                id="examenSelect"
                                value={selectedExamen}
                                onChange={(e) => { setSelectedExamen(e.target.value); setSelected(e.target.value) }}
                            >
                                <option value="">Seleccione un examen</option>
                                {examen.map((examenItem) => (
                                    <option key={examenItem.examen} value={examenItem.examen}>
                                        {examenItem.examen}
                                    </option>
                                ))}
                            </select>
                            <p></p>
                            <div>
                                <button className='separacion_p boton_per col-10' onClick={mostrarModal2}>
                                    Ver Preguntas
                                </button>
                                {
                                    showModal2 && (<Seleccionador2 onRestablecer={restablecer2} onContinuar={continuar2} />)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </>
    );
}


const Seleccionador = ({ onRestablecer, onContinuar }) => {
    return (
      <div>
        <p></p>
        <p className='advertencia'>Hay una antigua sesión que no realizó todas las preguntas. ¿Qué desea hacer?</p>
        {/* Aquí puedes tener otros botones o componentes */}
        <button className='boton_per_2' onClick={onRestablecer}>Empezar de 0</button>
        <button className='boton_per_2' onClick={onContinuar}>Continuar por donde lo dejé</button>
      </div>
    );
  };

  const Seleccionador2 = ({ onRestablecer, onContinuar }) => {
    return (
      <div>
        <p className='advertencia'>Hay una antigua sesión que no realizó todas las preguntas. ¿Qué desea hacer?</p>
        {/* Aquí puedes tener otros botones o componentes */}
        <button className='boton_per_2' onClick={onRestablecer}>Empezar de 0</button>
        <button className='boton_per_2' onClick={onContinuar}>Continuar por donde lo dejé</button>
        </div>
    );
  };
export default Preguntas_PER;
